<aims-side-menu [component]="permissions.ComponentID.Inventory">
    <ng-template>
        <aims-side-menu-header [displayText]="'Inventory'">
            <aims-side-menu-link [route]="'./config'"
                           [component]="permissions.ComponentID.InventoryConfig"
                           [iconClass]="'fas fa-cog'">
                Inventory Config
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./viewInventory'"
                                [component]="permissions.ComponentID.ViewInventory"
                                [permission]="menuPerms.read"
                                [iconClass]="'fas fa-table'">
                View Inventory
            </aims-side-menu-link>

            <aims-side-menu-link [route]="'./inventoryIbns'"
                                [component]="permissions.ComponentID.ViewInventory"
                                [permission]="menuPerms.read"
                                [iconClass]="'fas fa-chevron-circle-right'">
                Inventory-Ready Line Items
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./inventoryItemCreate'"
                                [component]="permissions.ComponentID.ViewInventory"
                                [permission]="menuPerms.create"
                                [iconClass]="'fas fa-plus'">
                Create Inventory Item
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./inventoryItem'"
                                [component]="permissions.ComponentID.ViewInventory"
                                [permission]="menuPerms.create"
                                [iconClass]="'fas fa-barcode'">
                Lookup Inventory Item
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./expendedInventory'"
                           [component]="permissions.ComponentID.ViewInventory"
                           [permission]="menuPerms.read"
                           [iconClass]="'fas fa-search'">
                Expended Inventory Search
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./receivedInventory'"
                           [component]="permissions.ComponentID.ViewInventory"
                           [permission]="menuPerms.read"
                           [iconClass]="'fas fa-search'">
                Received Inventory Search
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./importInventory'"
                            [component]="permissions.ComponentID.ViewInventory"
                            [permission]="menuPerms.create"
                            [iconClass]="'fas fa-file-import'">
                Import Inventory
            </aims-side-menu-link>
        </aims-side-menu-header>
        <aims-side-menu-header [displayText]="'Traveler'" [component]="components.Traveler">
            <aims-side-menu-link [route]="'./travelerConfig'"
                           [component]="permissions.ComponentID.InventoryConfig"
                           [iconClass]="'fas fa-cog'">
                Traveler Config
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./traveler'"
                           [component]="permissions.ComponentID.Traveler"
                           [permission]="menuPerms.create"
                           [iconClass]="'fas fa-plus'">
                Create Traveler
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./viewTravelers'"
                                [component]="permissions.ComponentID.Traveler"
                                [permission]="menuPerms.read"
                                [iconClass]="'fas fa-tasks'">
                View Travelers
            </aims-side-menu-link>
        </aims-side-menu-header>
        <aims-side-menu-header displayText="Reports">
            <aims-side-menu-link [route]="'../reporting/InventoryBarcode/trdp'"
                           [component]="permissions.ComponentID.ViewInventory"
                           [permission]="menuPerms.read"
                           [iconClass]="'fas fa-qrcode'">
                Print Label
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'../reporting/Inv_MinQtyReport/trdp'"
                           [component]="permissions.ComponentID.ViewInventory"
                           [permission]="menuPerms.read"
                           [iconClass]="'fas fa-sort-amount-up'">
                Minimum Quantity Report
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'../reporting/Inv_Status/trdp'"
                           [component]="permissions.ComponentID.Inventory"
                           [permission]="menuPerms.read"
                           [iconClass]="'fas fa-chart-line'">
                Inventory Status Report
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'../reporting/Inv_Overall/trdp'"
                           [component]="permissions.ComponentID.Inventory"
                           [permission]="menuPerms.read"
                           [iconClass]="'fas fa-cubes'">
                Inventory Report
            </aims-side-menu-link>
        </aims-side-menu-header>
    </ng-template>
</aims-side-menu>
